/** Altura visual do Navbar fixo; manter alinhado a `--navbar-height` em App.css */
export const NAVBAR_HEIGHT_CSS = '88px';
